// extracted by mini-css-extract-plugin
export default {"blockContent":"BlockContent_blockContent__tv8Yh"};